import { Option } from "api/common/types/common.types";

export const alphaSort = (a: string, b: string) => a?.localeCompare(b);

export const optionAlphaSort = (a: Option, b: Option) =>
  a?.label?.localeCompare(b?.label);
